import AVdxbCheckbox from './index.vue';

AVdxbCheckbox.install = app => {
  app.component(AVdxbCheckbox.name, AVdxbCheckbox);
};

export default AVdxbCheckbox;
